import { Data } from "../../data/address";

import ContactList from "./ContactList";

function Contact() {
  return (
    <section className="section contact" id="contact">
      <div className="container">
        <p className="card-subtitle">Email is Preferred </p>
        <h2 className="h2 section-title">Feel free to contact me</h2>
        <div className="contact-card">
          <div className="wrapper">
            {Data.map((addr) => {
              return <ContactList address={addr} key={addr.type} />;
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
export default Contact;
